import styled from 'styled-components';

import { ThemeProp } from '~/theme/Themes';

export const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  border-radius: ${(props: ThemeProp) => props.theme.borderRadius};
`;

export const Value = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.m};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
`;

export const ValueText = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.m};
`;
